<template>
    <div id="case">
        <v-alert dense border="bottom" type="primary" icon="mdi-information"
            >CASE INFORMATION<v-chip style="margin-left: 10px" color="grey">{{
                detailcase.team_name
            }}</v-chip>

            <!-- <span class="yellow--text">Team : {{ detailcase.team_name }}</span> -->
        </v-alert>
        <v-alert>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="6" sm="2" md="2">
                            <span class="font-weight-bold">Case Title : </span>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <span>{{ detailcase.case_title }}</span>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span class="font-weight-bold">Case Type :</span>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span>{{ detailcase.case_type }}</span>
                        </v-col>
                        <v-col cols="6" sm="2" md="2">
                            <span class="font-weight-bold">Refer Case :</span>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <span>{{ detailcase.case_refer }}</span>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span class="font-weight-bold">Problem Type :</span>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span>{{ detailcase.problem_type_name }}</span>
                        </v-col>
                        <v-col cols="6" sm="2" md="2">
                            <span class="font-weight-bold">Remark :</span>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <span>{{ detailcase.remark }}</span>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span class="font-weight-bold"
                                >Warranty Type :</span
                            >
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span>{{ detailcase.warranty_type }}</span>
                        </v-col>
                        <v-col cols="6" sm="2" md="2">
                            <span class="font-weight-bold">Created :</span>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <span>{{ detailcase.created_name }}</span>
                            <span style="margin-left: 20px">{{
                                detailcase.created_date
                            }}</span>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span class="font-weight-bold">SLA :</span>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span>{{ detailcase.case_sla }}</span>
                        </v-col>

                        <v-col cols="6" sm="2" md="2">
                            <span class="font-weight-bold">Closed :</span>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <span>{{ detailcase.closed_name }}</span>
                            <span style="margin-left: 20px">{{
                                detailcase.closed_date
                            }}</span>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span class="font-weight-bold"
                                >Date Time SLA :</span
                            >
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span>{{ detailcase.case_sla_datetime_x }}</span>
                        </v-col>
                        <v-col cols="6" sm="2" md="2">
                            <span class="font-weight-bold">HP Case :</span>
                        </v-col>
                        <v-col cols="6" sm="4" md="4">
                            <span>{{ detailcase.hp_case_id }}</span>
                            <!-- style="margin-left: 20px" -->
                            <span
                                ><span class="font-weight-bold">Type :</span>
                                {{ detailcase.type }}</span
                            >
                        </v-col>

                        <v-col cols="6" sm="3" md="3">
                            <!-- style="margin-left: 20px" -->
                            <span>
                                <span class="font-weight-bold">Dmr Flag :</span>
                            </span>
                        </v-col>
                        <v-col cols="6" sm="3" md="3">
                            <span
                                :class="
                                    detailcase.DmrFlag == 'Yes'
                                        ? 'red--text'
                                        : ''
                                "
                            >
                                {{ detailcase.DmrFlag }}
                            </span>
                        </v-col>

                        <v-col
                            cols="12"
                            sm="6"
                            md="6"
                            v-if="detailcase.Instructions"
                        >
                            <v-textarea
                                rows="6"
                                v-model="detailcase.Instructions"
                                outlined
                                label="Instructions"
                                required
                            ></v-textarea>
                            <!-- <span>{{ detailcase.Instructions }}</span> -->
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-alert>
    </div>
</template>
<script>
import axios from "axios"

export default {
    props: ["detailcase"],
    data() {
        return {}
    },
}
</script>
